import {Link} from 'react-router-dom';

import {QuestionSampleSets} from '~/features/AiSupport/QuestionSampleSets';

export const QuestionSampleSetsScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <div className="text-sm breadcrumbs p-4">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Question Sample Sets</li>
        </ul>
      </div>
      <QuestionSampleSets />
    </div>
  );
};
